import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-lg-12 text-left" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " ID ", -1)
const _hoisted_5 = { class: "col-6 text-right" }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Email ", -1)
const _hoisted_9 = { class: "col-6 text-right" }
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " First Name ", -1)
const _hoisted_13 = { class: "col-6 text-right" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Last Name ", -1)
const _hoisted_17 = { class: "col-6 text-right" }
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Status ", -1)
const _hoisted_21 = { class: "col-6 text-right" }
const _hoisted_22 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col d-flex justify-content-between align-items-center" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Two Factor Authentication ")
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "badge badge-success" }, " Enabled ", -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Two Factor Authentication ")
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "badge badge-danger" }, " Disabled ", -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fas fa-undo-alt" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12 col-lg-12" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "col d-flex justify-content-between align-items-center" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardBase = _resolveComponent("CardBase")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_CardBase, {
      allowBack: true,
      title: "Admin Details"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("code", null, _toDisplayString(_ctx.currentAdmin.id), 1)
              ])
            ]),
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("code", null, _toDisplayString(_ctx.currentAdmin.email), 1)
              ])
            ]),
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.currentAdmin.firstName), 1)
            ]),
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.currentAdmin.lastName), 1)
            ]),
            _hoisted_18,
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _createVNode("code", null, _toDisplayString(_ctx.currentAdmin.isActive ? 'ENABLED' : 'DISABLED'), 1)
              ])
            ]),
            _hoisted_22
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_CardBase, {
      allowBack: false,
      title: "Security options"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            (_ctx.currentAdmin.isTwoFactorAuthenticationEnabled)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30
                ])),
            _withDirectives(_createVNode("button", {
              disabled: !_ctx.currentAdmin.isTwoFactorAuthenticationEnabled,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetTwoFactorAuth && _ctx.resetTwoFactorAuth(...args))),
              class: "btn btn-sm btn-warning"
            }, [
              _hoisted_31,
              _hoisted_32
            ], 8, ["disabled"]), [
              [
                _directive_tooltip,
                'Reset',
                void 0,
                { top: true }
              ]
            ]),
            _createVNode(_component_ConfirmPopup)
          ]),
          _hoisted_33
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_CardBase, {
      allowBack: false,
      title: "Permissions"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPermissionList, (permission) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "row",
                    key: permission.name
                  }, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("b", null, _toDisplayString(permission.label), 1),
                      _createVNode(_component_InputSwitch, {
                        onChange: ($event: any) => (_ctx.changeConfig(permission)),
                        modelValue: permission.active,
                        "onUpdate:modelValue": ($event: any) => (permission.active = $event)
                      }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _hoisted_39
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}